const searchRules = {
  businessDepartmentCode: [{ required: true, message: '请选择部门', trigger: ['blur', 'change'] }],
  productParentName: [{ required: true, message: '请选择商品大类', trigger: ['blur', 'change'] }],
  externalPriceType: [{ required: true, message: '请选择价格类型', trigger: ['blur', 'change'] }],
  productProperty: [{ required: true, message: '请选择产品属性', trigger: ['blur', 'change'] }],
  startTime: [{ required: true, message: '请选择开始日期', trigger: ['blur', 'change'] }],
  endTime: [{ required: true, message: '请选择结束日期', trigger: ['blur', 'change'] }],
};
const tableRules = {
  productName: [{ required: true, message: '请输入产品名称' }],
  businessDepartmentName: [{ required: true, message: '请输入业务部门' }],
  productProperty: [{ required: true, message: '请选择产品属性' }],
  productStatus: [{ required: true, message: '请选择货物状态' }],
  externalPriceType: [{ required: true, message: '请选择价格类型' }],
  priceValue: [{ required: true, message: '请输入价格' }],
  tradeCurrencyCode: [{ required: true, message: '请选择交易货币' }],
  tradeMarket: [{ required: true, message: '请选择交易市场' }],
};

export { searchRules, tableRules };
